export const REGULAR_FAVICON = '/assets/images/favicon.ico';
export const FAVICON_2ND_FRAME = '/assets/images/favicon-frame-22-degrees.gif';

export const FAVICON_FRAMES = [REGULAR_FAVICON, FAVICON_2ND_FRAME];
export const FAVICON_ANIMATION_DELAY = 250;